import { OfficeWorkload } from '@office-start/officehome-types';
export var removeQueryParamsFromUrl = function (urlParams, paramsToRemove) {
    var updatedParams = new URLSearchParams();
    urlParams.forEach(function (value, key) {
        if (!paramsToRemove[key]) {
            updatedParams.append(key, value);
        }
    });
    return updatedParams;
};
export function getAppWorkloadType(workload) {
    if (workload === OfficeWorkload.Hwa) {
        if (typeof window.Office !== 'undefined') {
            return 'WebView2';
        }
        else {
            var webView2Version = new RegExp('1[0-9]{2}10');
            var wrapperVersion = Windows.ApplicationModel.Package.current.id.version;
            if ((wrapperVersion === null || wrapperVersion === void 0 ? void 0 : wrapperVersion.build) &&
                webView2Version.test(wrapperVersion.build.toString())) {
                // UWP appType launched as a fallback due to WebView2 runtime not installed on end user system
                return 'UWP_fallback';
            }
            else {
                return 'UWP';
            }
        }
    }
    else {
        return 'Web_React';
    }
}
//# sourceMappingURL=utils.js.map